import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useHealth } from "@/context/HealthAuthContext";
import { hError } from "@/lib/health";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function HealthLogin() {
  const { login } = useHealth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(email, password); navigate("/health/app"); }
    catch (err) { toast.error(hError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-b from-emerald-50 to-white px-4" data-testid="health-login">
      <div className="w-full max-w-sm">
        <Link to="/health" className="flex items-center justify-center gap-2 font-display font-bold text-emerald-700 text-lg mb-6"><ShieldCheck className="h-6 w-6" /> Mediva Health</Link>
        <div className="bg-white border border-emerald-100 rounded-2xl p-7 shadow-sm">
          <h1 className="text-xl font-semibold text-slate-900">Welcome back</h1>
          <p className="text-sm text-slate-500 mt-1">Log in to your health vault.</p>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" /></div>
            <div className="space-y-1.5"><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" /></div>
            <Button type="submit" disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="login-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Log in"}</Button>
          </form>
          <p className="text-sm text-slate-500 mt-5 text-center">New to Mediva Health? <Link to="/health/signup" className="text-emerald-700 font-medium" data-testid="to-signup">Create an account</Link></p>
        </div>
      </div>
    </div>
  );
}
